export default __webpack_public_path__ + "static/media/ShareNetwork.88560cff.svg";